var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resolvedSrc)?_c('img',_vm._b({attrs:{"src":_vm.resolvedSrc},on:{"load":_vm.onLoad,"error":_vm.onError}},'img',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }